import Assessment from '../assessment';

/**
 * Create the action
 */

const { thunk, request, success, error } = Assessment.update((data, fetch) => {
  // Prepare request
  data._method = 'PUT';

  if (data.markAsDone === 1) {
    return fetch.post(`/assessments-mark-done/${data.id}`, data);
  }

  return fetch.post(`/assessments/${data.id}`, data);
});

/**
 * Export the components
 */

export { thunk as default };
export { request, success, error };
